import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pa-2" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-space-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, { ref: "put_report_form" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_textarea, {
          modelValue: _ctx.stateOfChild,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stateOfChild) = $event)),
          rules: [_ctx.rules.counter500],
          readonly: !_ctx.isDraft,
          "auto-grow": "",
          outlined: "",
          dense: ""
        }, null, 8, ["modelValue", "rules", "readonly"]),
        (_ctx.isDraft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickPost({ isDraft: true }))),
                class: "flex",
                color: "primary",
                loading: _ctx.draftLoading,
                outlined: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tSaveDraft), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_v_btn, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickPost({ isDraft: false }))),
                class: "flex ml-2",
                color: "primary",
                loading: _ctx.sendLoading,
                depressed: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tSubmit), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ]))
}